// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"79895356","896":"e4be4607"}[chunkId] + ".chunk.js";
};